export default function Contactinfo(){
    return(
        <div className="pr-5 pl-5 pb-5">
            <h2 className="text-center pb-5 mt-5" style={{fontWeight:"600", fontSize:"40px"}}>Contact our support team to know <br />what you want</h2>            
            <div className="row p-5">

                <div className='col-sm-4 mt-3'>
                    <div style={{backgroundColor:"rgb(232, 236, 245)", Height: "400px", maxWidth: "400px", padding: "70px 0px", textAlign: "center"}}>
                        <h3>Our Numbers</h3>
                        <span>+234 803 930 8845,</span><span> +234 802 056 4173</span><br /><br />
                        <span>+234 817 758 2762,</span><span> +234 706 737 0051</span>
                    </div> 
                </div>

                <div className='col-sm-4 mt-3'>
                    <div style={{backgroundColor:"rgb(250, 225, 225)", height: "400px", padding: "70px 0px", textAlign: "center"}}>
                        <h3>Email Address</h3>
                        <span>info@3keyslogisticsltd.com.ng</span><br />
                        <span>support@3keyslogisticsltd.com.ng</span><br /><br />
                    </div>
                </div>

                <div className='col-sm-4 mt-3'>
                    <div style={{backgroundColor:"rgb(220, 240, 224)", maxHeight: "400px", minHeight: "200px", maxWidth: "400px", padding: "20px 0px", textAlign: "center"}}>
                        <h3>Our Location</h3>
                        <span><u>Head Office:</u></span><br />
                        <span>21, Abiola Generation Street, Saka, Ajegunle/Alagbado,
                        Lagos, Nigeria.</span><br /><br />

                        <span><u>Abuja Office:</u></span><br />
                        <span>First Generational Plaza, Aco Estate, Lugbe, Phase 2, Abuja</span>
                    </div> 
                </div>

            </div>
        </div>
    );
}